const _rawBase = process.env.REACT_APP_API_URL || "https://ogm-service-756477950725.asia-south1.run.app/api";

export const API_BASE = _rawBase.endsWith("/api") ? _rawBase : _rawBase.replace(/\/$/, "") + "/api";

if (process.env.NODE_ENV === "development") {
    console.log("[API] Using endpoint:", API_BASE);
}

export const ENDPOINTS = {
  AI_ASK:   `${API_BASE}/ai/ask`,
  AGENT_ASK:`${API_BASE}/agent/ask`,
};

export const FALLBACK_IMAGE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23f1f3f4'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='16' fill='%23aab4c4'%3ENo Image%3C/text%3E%3C/svg%3E";


export const DEFAULT_SUGGESTIONS = [
  {
    label: "4 BHK Villa in Gattahalli",
    value: "tell me about The Singapore Residences in Gattahalli",
    icon:  "🏡",
    category: "property",
  },
  {
    label: "2-3 BHK in Kasavanahalli",
    value: "show me apartments in Kasavanahalli near HSR layout",
    icon:  "🏠",
    category: "location",
  },
  {
    label: "2 BHK near Wipro Gate",
    value: "2 bhk apartments near old wipro gate junnasandra",
    icon:  "💻",
    category: "location",
  },
  {
    label: "Sobha Dream Acres 2 BHK",
    value: "tell me about Sobha Dream Acres in Varthur",
    icon:  "🌿",
    category: "property",
  },
  {
    label: "Holiday villa in Tamil Nadu",
    value: "show me hello bali holiday homes",
    icon:  "🌴",
    category: "lifestyle",
  },
  {
    label: "2-4 BHK off Sarjapur Road",
    value: "apartments near sarjapur attibele road",
    icon:  "📍",
    category: "location",
  },
  {
    label: "Villa plots in Hosur Road",
    value: "villas on sarjapur bagalur road hosur",
    icon:  "🌱",
    category: "investment",
  },
  {
    label: "Luxury villa Electronic City",
    value: "luxury villa in electronic city bangalore",
    icon:  "⚡",
    category: "type",
  },
];


export const SUGGESTION_CARDS = [
  {
    title:    "Singapore Residences",
    subtitle: "₹6.32 Cr · 4 BHK Villa · Gattahalli, Bengaluru",
    query:    "tell me about The Singapore Residences in Gattahalli",
    icon:     "🏡",
    tag:      "Premium Villa",
    tagColor: "#f97316",
  },
  {
    title:    "Kasavanahalli Heights",
    subtitle: "₹1.25 Cr · 2-3 BHK · Near HSR Layout",
    query:    "apartments in Kasavanahalli Heights near HSR layout",
    icon:     "🏠",
    tag:      "Popular",
    tagColor: "#7c3aed",
  },
  {
    title:    "Junnasandra Enclave",
    subtitle: "₹40 L · 2-3 BHK · Near Old Wipro Gate",
    query:    "2 bhk apartments near old wipro gate junnasandra",
    icon:     "💻",
    tag:      "IT Hub",
    tagColor: "#2563eb",
  },
  {
    title:    "Sobha Dream Acres",
    subtitle: "₹75.5 L · 2 BHK · Varthur, Bengaluru",
    query:    "Sobha Dream Acres 2 bhk in Varthur",
    icon:     "🌿",
    tag:      "Gated Community",
    tagColor: "#16a34a",
  },
  {
    title:    "Hello Bali Holiday Homes",
    subtitle: "₹1.25 Cr · 2 BHK · Nariyanahalli, Tamil Nadu",
    query:    "hello bali holiday homes resort villa",
    icon:     "🌴",
    tag:      "Weekend Retreat",
    tagColor: "#0891b2",
  },
];

export const KEYBOARD_SHORTCUTS = {
  NEW_CHAT:       "n",
  SEARCH:         "k",
  TOGGLE_SIDEBAR: "b",
  TOGGLE_THEME:   "j",
};
